// import pictures
import freshmanFormal from '../images/our-story/freshman_year_formal.JPG';
import freshmanAddams from '../images/our-story/freshman_year_addams.JPEG';
import meelo from '../images/our-story/meelo_thanksgiving.jpg';
import house from '../images/our-story/bought_house.JPG';
import van from '../images/our-story/bought-van.jpg';
import italy from '../images/our-story/italy.JPG';
import engagement from '../images/our-story/engagement.jpg';
import rockies from '../images/our-story/rockies.JPG';
import mexico from '../images/our-story/mexico.jpg';

const ourStoryArray = [
  {
    key: 1,
    header: 'August 2016',
    subHeader: 'Semi-Formal',
    text: 'We first became friends at the beginning of our freshman year, after Abby successfully inserted herself into the Stever 1 crew. Andrew had his first semi-formal in September and Abby was his third choice!',
    image: freshmanFormal,
    alt: 'Freshman Formal',
  },
  {
    key: 2,
    header: 'October/November 2016',
    subHeader: 'Addams Family Performance',
    text: 'This was the first time Andrew saw Abby performing, as Wednesday in The Addams Family. We both had feelings for each other at this point, but we were trying to hide it. Andrew asked Abby to be his girlfriend shortly after this in November.',
    image: freshmanAddams,
    alt: 'Addams Family Performance',
  },
  {
    key: 3,
    header: 'November 2020',
    subHeader: 'Meelo!',
    text: 'After enduring CMU together and graduating in May of 2020, we finally got our own apartment together and adopted the best most special boy in the entire world. Meelo completed our family.',
    image: meelo,
    alt: 'Adopting Meelo',
  },
  {
    key: 4,
    header: 'March 2021',
    subHeader: 'Bought Our Home!',
    text: "While we loved our first home on Stanton Ave in Pittsburgh's Highland Park neighborhood, we knew we wanted to be able to own our own place, so in March of this year we bought our first home in Pittsburgh's Holla!",
    image: house,
    alt: 'Buying A Home',
  },
  {
    key: 5,
    header: 'May 2021',
    subHeader: 'First "Real" Vacation Together',
    text: "In the summer of 2021, we took our first real vacation together to Valladolid in Mexico! Technically, our first true vacation was to Ocean City Maryland as two broke junior's in college, and while that vacation will always hold an extremely special place in our hearts, our trip to Mexico ignited a passion to travel and explore the world together.",
    image: mexico,
    alt: 'Mexico Vacation',
  },
  {
    key: 6,
    header: 'May 2022',
    subHeader: 'Getting Out in Nature',
    text: 'Along with our growing passion for international travel, we also got really into the outdoors and started taking up hiking and climbing.',
    image: rockies,
    alt: 'Rocky Mountain Hiking',
  },
  {
    key: 7,
    header: 'September 2023 - ??',
    subHeader: 'First, But Not Last European Excurscion',
    text: "Italy was both of our first time's in Europe and we both fell in love with it! Little did we know we would be having our wedding here. Since Italy, we've been able to visit The Netherlands, France, Croatia, Belgium, Germany, Austria, Portugal, Finland, Latvia, Estonia and Spain as part of our European travels.",
    image: italy,
    alt: 'Italy Vacation',
  },
  {
    key: 8,
    header: 'April 2024',
    subHeader: 'We Bought a Van!',
    text: "Van life was a bucketlist item we both wanted to be able to accomplish in our lifetime. After searching for a few months, we finally found and bought our van (The Abby-Mobile, as my Uncle Tom has deemed it) in April. This is us celebrating at a local hot dog joint. We can't wait to continue building it out and get to explore all the national parks. ",
    image: van,
    alt: 'Bought a Van',
  },
  {
    key: 9,
    header: 'July 2024',
    subHeader: 'Engaged!!!',
    text: 'In the most Andrew fashion possible, he proposed to Abby at our home on July 13th, 2024. It was truly memorable and even though Abby knew he had the ring since February (and was the ONLY person to know about it, besides Manu), she was very surprised and happy. ',
    image: engagement,
    alt: 'Engaged',
  },
];
export default ourStoryArray;
